import type { AdsPageLineItem } from '../../../../common/AdForm/types';

export function getCountryCodesFromLineItem(lineItem?: AdsPageLineItem): string[] {
  if (!lineItem?.targetingTermValues) return [];

  return lineItem.targetingTermValues
    .filter((targetingTermValue) => targetingTermValue.dimension?.id === 'country' && targetingTermValue.value?.id)
    .map((targetingTermValue) => targetingTermValue.value?.id || '');
}
